export const parseSectionContent = (content) => {
  if (!content) return {};

  if (typeof content === 'string') {
    try {
      const parsed = JSON.parse(content);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return { body: content };
    }
  }

  if (typeof content === 'object') {
    return content;
  }

  return {};
};
